export default __webpack_public_path__ + "static/media/dangerIcon.6c350e95.svg";